import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Heart } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Sponsors = () => {
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSponsors();
  }, []);

  const loadSponsors = async () => {
    try {
      const response = await axios.get(`${API}/sponsors`);
      setSponsors(response.data);
    } catch (error) {
      console.error('Error loading sponsors:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section id="sponsorer" className="py-24 bg-[#faf7f2]">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-gray-500">Indlæser sponsorer...</p>
        </div>
      </section>
    );
  }

  return (
    <section id="sponsorer" className="py-24 bg-[#faf7f2]" aria-labelledby="sponsors-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <header className="text-center mb-16">
          <span className="inline-block text-[#1a472a] font-semibold text-sm uppercase tracking-wider mb-4">
            Sponsorer
          </span>
          <h2 id="sponsors-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Tak til vores støtter
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Uden disse fantastiske virksomheder og organisationer ville juletræsfesten ikke være mulig.
          </p>
        </header>

        {/* Sponsors Grid */}
        {sponsors.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {sponsors.map((sponsor) => (
              <div
                key={sponsor.id}
                className="group bg-white rounded-2xl p-6 sm:p-8 shadow-sm border border-gray-100 hover:border-[#1a472a]/20 flex items-center justify-center min-h-[120px] transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              >
                {sponsor.website ? (
                  <a
                    href={sponsor.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-700 font-semibold text-center group-hover:text-[#1a472a] transition-colors duration-300"
                  >
                    {sponsor.name}
                  </a>
                ) : (
                  <span className="text-gray-700 font-semibold text-center group-hover:text-[#1a472a] transition-colors duration-300">
                    {sponsor.name}
                  </span>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-gray-500">Ingen sponsorer endnu</p>
        )}

        {/* Become Sponsor CTA */}
        <div className="mt-16 bg-white rounded-3xl p-8 sm:p-12 border border-gray-100 text-center">
          <div className="w-16 h-16 bg-[#c41e3a]/10 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Heart className="w-8 h-8 text-[#c41e3a]" />
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Bliv sponsor
          </h3>
          <p className="text-gray-600 max-w-xl mx-auto mb-6">
            Ønsker din virksomhed at støtte et godt formål og være med til at skabe juleglæde for udsatte børn? Kontakt os for at høre om mulighederne.
          </p>
          <a
            href="#kontakt"
            className="inline-flex items-center gap-2 bg-[#1a472a] hover:bg-[#2d5a3d] text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 hover:shadow-lg"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#kontakt')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Kontakt os
          </a>
        </div>
      </div>
    </section>
  );
};

export default Sponsors;
